export default {
    domain: "http://139.162.39.138:1338"
    // domain: "http://localhost:1338"
}